import * as actions from "./actions";

const initialState = {
	items: [],
	filter: [],
	pages: null,
	count: 0,
	loading: { getAll: false, import: false },
	errors: {},
	contract: {
		name: null,
		idTemplate: null
	}
};

const reducer = function(state = initialState, { type, payload }) {
	switch (type) {
		case actions.GET_CONTRACTS_TEMPLATE: {
			return {
				...state,
				loading: { getAll: true },
				errors: initialState.errors
			};
		}
		case actions.GET_CONTRACTS_TEMPLATE_SUCCESS: {
			return {
				...state,
				items: payload || [],
				loading: { getAll: false }
			};
		}
		case actions.GET_CONTRACTS_TEMPLATE_FAILED: {
			return {
				...state,
				loading: { getAll: false },
				errors: payload
			};
		}

		case actions.SET_VALUE:
			return {
				...state,
				...payload
			};
		case actions.CLEAR_VALUES:
			return {
				...initialState
			};
		default: {
			return state;
		}
	}
};

export default reducer;
